import React from 'react'
import { Switch, Route } from 'react-router-dom'
import EditFrontpageContainer from '../containers/editFrontpageContainer'

export default ({ match }) => (
  <Switch>
    <Route path={`${match.path}`} component={EditFrontpageContainer} />
  </Switch>
)
